'use strict';

const formatString = {
  ko: {
    weekday: "EEEE",
    weekday_short: "EEE",
    time: "aa h:mm",
    time_short: "HH:mm",
    year: "y\uB144",
    year_yearMin: "yy\uB144",
    year_month: "y\uB144 M\uC6D4",
    year_month_yearMin: "yy\uB144 M\uC6D4",
    year_month_short: "y. M",
    year_month_yearMin_short: "yy. M",
    month: "M\uC6D4",
    month_day: "M\uC6D4 d\uC77C",
    month_day_short: "M. d",
    month_day_weekday: "M\uC6D4 d\uC77C (EEE)",
    month_day_weekday_short: "M. d (EEE)",
    day_of_month: "do",
    date: "y\uB144 M\uC6D4 d\uC77C",
    date_short: "y. M. d",
    date_yearMin_short: "yy. M. d",
    date_weekday: "y\uB144 M\uC6D4 d\uC77C (EEE)",
    date_weekday_short: "y. M. d (EEE)",
    datetime: "y\uB144 M\uC6D4 d\uC77C aa h:mm",
    datetime_short: "y. M. d aa h:mm",
    datetime_seconds: "y\uB144 M\uC6D4 d\uC77C aa h:mm:ss",
    datetime_seconds_short: "y. M. d a h:mm:ss",
    datetime_weekday: "y\uB144 M\uC6D4 d\uC77C (EEE) aa h:mm",
    datetime_weekday_short: "y. M. d (EEE) aa h:mm",
    month_day_time: "M\uC6D4 d\uC77C aa h:mm",
    month_day_time_short: "M. d aa h:mm",
    month_day_time_weekday: "M\uC6D4 d\uC77C (EEE) aa h:mm",
    month_day_time_weekday_short: "M. d (EEE) aa h:mm"
  },
  en: {
    weekday: "EEEE",
    weekday_short: "EEE",
    time: "h:mm aa",
    time_short: "HH:mm",
    year: "y",
    year_yearMin: "yy",
    year_month: "MMMM, y",
    year_month_yearMin: "MMMM, yy",
    year_month_short: "MMM, y",
    year_month_yearMin_short: "MMM, yy",
    month: "MMMM",
    month_day: "MMMM d",
    month_day_short: "MMM d",
    month_day_weekday: "EEEE, MMM d",
    month_day_weekday_short: "EEEE, MMM d",
    day_of_month: "do",
    date: "MMM d, y",
    date_short: "MMM d, y",
    date_yearMin_short: "MMM d, yy",
    date_weekday: "EEEE, MMM d, y",
    date_weekday_short: "EEEE, MMM d, y",
    datetime: "MMM d, y 'at' h:mm aa",
    datetime_short: "MMM d, y 'at' h:mm aa",
    datetime_seconds: "MMM d, y 'at' h:mm:ss a",
    datetime_seconds_short: "MMM d, y 'at' h:mm:ss a",
    datetime_weekday: "EEEE, MMM d, y 'at' h:mm aa",
    datetime_weekday_short: "EEEE, MMM d, y 'at' h:mm aa",
    month_day_time: "MMM d 'at' h:mm aa",
    month_day_time_short: "MMM d 'at' h:mm aa",
    month_day_time_weekday: "EEEE, MMM d 'at' h:mm aa",
    month_day_time_weekday_short: "EEEE, MMM d 'at' h:mm aa"
  }
};
const getFormatStringForSingleTimePreset = (presetName, locale) => {
  return formatString[locale][presetName];
};

exports.getFormatStringForSingleTimePreset = getFormatStringForSingleTimePreset;
//# sourceMappingURL=getFormatStringForSingleTimePreset.cjs.map
